import { Route, Redirect } from 'react-router-dom';
import React from 'react';

import { definePrivileges } from './authorization';
import ChooseNewPassword from './components/login-register/ChooseNewPassword.js';
import CookiesPage from './components/info-pages/Cookies.js';
import DemandRoutes from './components/demand/routes.js';
import EmailSent from './components/login-register/EmailSent.js';
import ForgotPassword from './components/login-register/ForgotPassword.js';
import InfoPages from './components/info-pages/InfoPages.js';
import LandingPage from './components/home/index';
import LoginRegister from './components/login-register/LoginRegister.js';
import NoMatch from './components/NoMatch.js';
import Supply from './components/supply/components/Main';
import AdminPage from './components/admin';

export const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  allowedRoles,
  role,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      return isAuthenticated &&
        definePrivileges(role).can('see', rest.path.slice(1) || '') ? (
        <Component role={role} {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      );
    }}
  />
);

const routes = [
  {
    path: '/',
    exact: true,
    component: LandingPage,
    protected: false,
  },
  {
    path: '/login',
    exact: false,
    component: LoginRegister,
    protected: false,
  },
  {
    path: '/registration',
    exact: false,
    component: LoginRegister,
    protected: false,
  },
  {
    path: '/forgot_password',
    exact: false,
    component: ForgotPassword,
    protected: false,
  },
  {
    path: '/email-sent',
    exact: false,
    component: EmailSent,
    protected: false,
  },
  {
    path: '/choose_new_password',
    exact: false,
    component: ChooseNewPassword,
    protected: false,
  },
  {
    path: '/admin',
    exact: false,
    component: AdminPage,
    protected: true,
  },
  {
    path: '/about',
    exact: false,
    component: InfoPages,
    protected: false,
  },
  {
    path: '/terms-and-conditions',
    exact: false,
    component: InfoPages,
    protected: false,
  },
  {
    path: '/privacy-policy',
    exact: false,
    component: InfoPages,
    protected: false,
  },
  {
    path: '/cookies',
    exact: false,
    component: CookiesPage,
    protected: false,
  },
  {
    path: '/faq',
    exact: false,
    component: InfoPages,
    protected: false,
  },
  {
    path: '/contact',
    exact: false,
    component: InfoPages,
    protected: false,
  },
  {
    path: '/demand',
    exact: false,
    component: DemandRoutes,
    protected: true,
    allowedRoles: [
      'ROLE_DESIGNER_LIGHTING',
      'ROLE_ELECTRICAL_ENGINEER',
      'ROLE_ARCHITECT',
      'ROLE_INTERIOR_DESIGNER',
      'ROLE_AV_DESIGNER',
    ],
  },
  {
    path: '/supply',
    exact: false,
    component: Supply,
    protected: true,
    allowedRoles: [
      'ROLE_MANUFACTURER',
      'ROLE_AGENT',
      'ROLE_DISTRIBUTOR',
      'ROLE_REPRESENTATIVE',
    ],
  },
  {
    path: null,
    exact: false,
    component: NoMatch,
    protected: false,
  },
];

export default routes;
